module.exports = __webpack_public_path__ + "img/1.7e060e56.gif";